<template>
    <div class="container py-5">
        <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6">
                <div class="card shadow-sm" v-show="show">
                    <div class="card-body" v-if="urThief">
                        <h4 class="card-title mb-3">
                            <i class="fas fa-bomb"></i>
                            不正なアクセスです
                        </h4>
                        <p class="card-text text-danger">
                            参照元のURLを取得できませんでした。
                            貸し本棚の外部からのアクセスか、
                            ブラウザの設定上の問題があります。
                        </p>
                    </div>
                    <div class="card-body" v-else-if="isDanger">
                        <h4 class="card-title mb-3">
                            <i class="fas fa-skull-crossbones"></i>
                            このリンク先は危険です
                        </h4>
                        <p class="card-text text-danger" v-if="hasMalware">
                            指定のリンク先は<strong>マルウェア</strong>を含んでいる可能性があります！
                        </p>
                        <p class="card-text text-danger" v-if="hasSocialHacking">
                            指定のリンク先は<strong>フィッシング・虚偽の情報</strong>を含んでいる可能性があります！
                        </p>
                        <p class="card-text">
                            これらのリンク先は貸し本棚から直接遷移することはできません。
                            ご自身の責任において、URLを開くことはできますが、推奨されません。
                        </p>
                        <div class="mb-3">
                            <strong>危険なリンク先：</strong>
                            <div class="text-break text-danger mt-1">
                                {{ $route.query.url }}
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-else-if="isRisky">
                        <h4 class="card-title mb-3 text-warning">
                            <i class="fas fa-exclamation-triangle"></i>
                            問題のある外部リンクに移動します
                        </h4>
                        <p class="card-text" v-if="hasTechnicalProblem">
                            <strong>技術的に問題</strong>
                            のある可能性のある外部サイトに遷移しようとしています。
                            リンク先を確認し、「外部サイトへ進む」ボタンをクリックしてください。
                        </p>
                        <p class="card-text text-warning" v-if="hasUnwantedSoftware">
                            <strong>望まないソフトウェア</strong>
                            を含む可能性のある外部サイトに遷移しようとしています。
                            リンク先を確認し、「外部サイトへ進む」ボタンをクリックしてください。
                        </p>
                        <p class="card-text">
                            正しく遷移できない場合は、以下のリンク先をコピーしてアドレス欄に貼り付けてください。
                        </p>
                        <div class="mb-3">
                            <strong>問題のあるリンク先：</strong>
                            <div class="text-break text-warning mt-1">
                                {{ $route.query.url }}
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-outline-secondary" @click="close()">
                                <i class="fas fa-times"></i>
                                閉じる
                            </button>
                            <button class="btn btn-outline-warning" @click="jumpTo()">
                                <i class="fas fa-exclamation-triangle"></i>
                                外部サイトへ進む
                            </button>
                        </div>
                    </div>
                    <div class="card-body" v-else-if="$route.query.url">
                        <h4 class="card-title mb-3">外部リンクに移動します</h4>
                        <p class="card-text">
                            外部サイトに遷移しようとしています。
                            リンク先を確認し、「外部サイトへ進む」ボタンをクリックしてください。
                        </p>
                        <p class="card-text">
                            正しく遷移できない場合は、以下のリンク先をコピーしてアドレス欄に貼り付けてください。
                        </p>
                        <div class="mb-3">
                            <strong>リンク先：</strong>
                            <div class="text-break text-primary mt-1">
                                {{ $route.query.url }}
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-outline-secondary" @click="close()">
                                <i class="fas fa-times"></i>
                                閉じる
                            </button>
                            <button class="btn btn-outline-primary" @click="jumpTo()">
                                <i class="fas fa-external-link-alt"></i>
                                外部サイトへ進む
                            </button>
                        </div>
                    </div>
                    <div v-else class="card-body">
                        <h4 class="card-title mb-3">無効なリンクです</h4>
                        <p class="card-text">指定されたリンクが見つかりませんでした。</p>
                        <a href="/" class="btn btn-secondary">ホームへ戻る</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            threats: [],
            urThief: false,
            show: false,
        }
    },
    methods: {
        load() {
            if (this.$route.query.url) {
                axios.post("/check/url", {
                    url: this.$route.query.url,
                    token: this.$route.query.token,
                }).then(res => {
                    this.threats = res.data;
                }).catch(err => {
                    alert.err(err);
                }).finally(() => {
                    this.show = true;
                });
            } else {
                this.show = true;
            }
        },
        jumpTo() {
            const a = document.createElement("a");
            a.href = this.$route.query.url;
            a.rel = "noreferrer noopener";
            a.click();
        },
        close() {
            window.close();
        },
    },
    computed: {
        isDanger() {
            return this.hasMalware || this.hasSocialHacking;
        },
        isRisky() {
            return this.hasUnwantedSoftware || this.hasTechnicalProblem;
        },
        hasMalware() {
            return this.threats.includes("MALWARE");
        },
        hasSocialHacking() {
            return this.threats.includes("SOCIAL_ENGINEERING") || this.threats.includes("SOCIAL_ENGINEERING_EXTENDED_COVERAGE");
        },
        hasUnwantedSoftware() {
            return this.threats.includes("UNWANTED_SOFTWARE");
        },
        hasTechnicalProblem() {
            return this.threats.includes("TECHNICAL_PROBLEM");
        },
    },
    mounted() {
        const referrer = document.referrer;
        if (!referrer || referrer.length === 0) {
            this.urThief = true;
            this.show = true;
            return;
        }
        const referrerUrl = new URL(referrer);
        const referrerHost = referrerUrl.hostname;
        setTimeout(() => {
            const regex =new RegExp(this.$store.state.base_domain + '$');
            if (referrerHost.match(regex)) {
                this.load();
            }
        }, 800);
    }
}
</script>